import { DateService } from './DateService';

/**
 * Returns today's date as YYYY-MM-DD in Europe/Prague timezone.
 * Respects DateService simulated dates for testing.
 */
export function getPragueDate(date?: Date): string {
    const d = date || DateService.now();
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Prague',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(d);
}

/**
 * Returns yesterday's date as YYYY-MM-DD in Europe/Prague timezone.
 */
export function getPragueDateYesterday(date?: Date): string {
    const d = date || DateService.now();
    const yesterday = new Date(d.getTime() - 86400000);
    return getPragueDate(yesterday);
}
